export enum Stage {
  Dev = 'dev',
  Qas = 'qas',
  Run = 'run',
}

export const Stages = Object.values(Stage);
